import { normalize } from 'normalizr'
import { Schemas } from '@redux/schema'
import { updateEntities, deleteEntity } from '@redux/entities'

import api from '@functions/api'

import { handleError } from '../utils'

const FETCH_REQUEST = 'contenthouse/filter/FETCH_REQUEST'
const FETCH_SUCCESS = 'contenthouse/filter/FETCH_SUCCESS'
const FETCH_FAILURE = 'contenthouse/filter/FETCH_FAILURE'

const CREATE_REQUEST = 'contenthouse/filter/CREATE_REQUEST'
const CREATE_SUCCESS = 'contenthouse/filter/CREATE_SUCCESS'
const CREATE_FAILURE = 'contenthouse/filter/CREATE_FAILURE'

const UPDATE_REQUEST = 'contenthouse/filter/UPDATE_REQUEST'
const UPDATE_SUCCESS = 'contenthouse/filter/UPDATE_SUCCESS'
const UPDATE_FAILURE = 'contenthouse/filter/UPDATE_FAILURE'

const DELETE_REQUEST = 'contenthouse/filter/DELETE_REQUEST'
const DELETE_SUCCESS = 'contenthouse/filter/DELETE_SUCCESS'
const DELETE_FAILURE = 'contenthouse/filter/DELETE_FAILURE'

// Initial State
const initialState = {
  creating: false,
  deleting: false,
  errors: [],
  loaded: false,
  loading: false,
  updating: false,
}

// Actions
export function fetchRequest() {
  return {
    type: FETCH_REQUEST,
  }
}

export function fetchSuccess() {
  return {
    type: FETCH_SUCCESS,
  }
}

export function fetchFailure(errors = []) {
  return {
    type: FETCH_FAILURE,
    errors,
  }
}

export function createRequest() {
  return {
    type: CREATE_REQUEST,
  }
}

export function createSuccess() {
  return {
    type: CREATE_SUCCESS,
  }
}

export function createFailure(errors = []) {
  return {
    type: CREATE_FAILURE,
    errors,
  }
}

export function updateRequest() {
  return {
    type: UPDATE_REQUEST,
  }
}

export function updateSuccess() {
  return {
    type: UPDATE_SUCCESS,
  }
}

export function updateFailure(errors = []) {
  return {
    type: UPDATE_FAILURE,
    errors,
  }
}

export function deleteRequest() {
  return {
    type: DELETE_REQUEST,
  }
}

export function deleteSuccess() {
  return {
    type: DELETE_SUCCESS,
  }
}

export function deleteFailure(errors = []) {
  return {
    type: DELETE_FAILURE,
    errors,
  }
}

export function loadFilters(options) {
  return (dispatch) => {
    dispatch(fetchRequest())

    const promise = api('/v1/filters', options)
      .then(({ data }) => {
        const normalizedJson = normalize(data, Schemas.FILTER_ARRAY)
        dispatch(updateEntities(normalizedJson))
        dispatch(fetchSuccess())

        return { success: true, data }
      })
      .catch((data) => {
        const errors = handleError(data)
        dispatch(fetchFailure(errors))

        return { success: false, errors }
      })

    return promise
  }
}

export function loadFilter(id, dispatch) {
  dispatch(fetchRequest())

  const promise = api(`/v1/filters/${id}`, {})
    .then(({ data }) => {
      const normalizedJson = normalize(data, Schemas.FILTER)
      dispatch(updateEntities(normalizedJson))
      dispatch(fetchSuccess())

      return { success: true, data }
    })
    .catch((data) => {
      const errors = handleError(data)
      dispatch(fetchFailure(errors))

      return { success: false, errors }
    })

  return promise
}

export function createFilter(filter, options) {
  const config = {
    method: 'POST',
    data: filter,
  }

  return (dispatch) => {
    dispatch(createRequest())

    const promise = api('/v1/filters', options, config)
      .then(({ data }) => {
        dispatch(createSuccess())

        return loadFilter(data, dispatch)
      })
      .catch((data) => {
        const errors = handleError(data)
        dispatch(createFailure(errors))

        return { success: false, errors }
      })

    return promise
  }
}

export function updateFilter(filter, options) {
  const config = {
    method: 'PUT',
    data: filter,
  }

  return (dispatch) => {
    dispatch(updateRequest())

    const promise = api(`/v1/filters/${filter.id}`, options, config)
      .then(({ data }) => {
        dispatch(updateSuccess())

        return loadFilter(filter.id, dispatch)
      })
      .catch((data) => {
        const errors = handleError(data)
        dispatch(updateFailure(errors))

        return { success: false, errors }
      })

    return promise
  }
}

export function deleteFilter(filter) {
  const config = {
    method: 'DELETE',
  }

  return (dispatch) => {
    dispatch(deleteRequest())

    const promise = api(`/v1/filters/${filter.id}`, {}, config)
      .then(({ data }) => {
        const normalizedJson = normalize(filter, Schemas.FILTER)
        dispatch(deleteEntity(normalizedJson))
        dispatch(deleteSuccess())

        return { success: true, data }
      })
      .catch((data) => {
        const errors = handleError(data)
        dispatch(deleteFailure(errors))

        return { success: false, errors }
      })
    return promise
  }
}

// Reducer
export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case FETCH_REQUEST:
      return {
        ...state,
        loading: true,
      }
    case FETCH_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        errors: [],
      }
    case FETCH_FAILURE:
      return {
        ...state,
        loading: false,
        loaded: false,
        errors: action.errors,
      }
    case CREATE_REQUEST:
      return {
        ...state,
        creating: true,
      }
    case CREATE_SUCCESS:
      return {
        ...state,
        creating: false,
        errors: [],
      }
    case CREATE_FAILURE:
      return {
        ...state,
        creating: false,
        errors: action.errors,
      }
    case UPDATE_REQUEST:
      return {
        ...state,
        updating: true,
      }
    case UPDATE_SUCCESS:
      return {
        ...state,
        updating: false,
        errors: [],
      }
    case UPDATE_FAILURE:
      return {
        ...state,
        updating: false,
        errors: action.errors,
      }
    case DELETE_REQUEST:
      return {
        ...state,
        deleting: true,
      }
    case DELETE_SUCCESS:
      return {
        ...state,
        deleting: false,
        errors: [],
      }
    case DELETE_FAILURE:
      return {
        ...state,
        deleting: false,
        errors: action.errors,
      }
    default:
      return state
  }
}